import { useTranslation } from '@/shared/i18n/use-translation';

type PendingDotProps = {
  readonly pending: boolean;
};

export function PendingDot({ pending }: PendingDotProps) {
  const { t } = useTranslation();
  if (!pending) return null;
  return (
    <span className="size-2 shrink-0 rounded-full bg-warn" title={t('Waiting to sync')}>
      <span className="sr-only">{t('Waiting to sync')}</span>
    </span>
  );
}
